<template>
  <div class="home">
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  name: 'Home',
  extends: BaseVue,
  components: {
  },

  data() {
    return {
    }
  },

  created() {
  },

  methods: {
  }
}
</script>
